import { memo, Fragment, ReactNode } from "react"

import { ClientDiscount } from "utils/interfaces"
import { nonNullable } from "utils/nonNullable"

function formatReminderDeposit(deposit: string) {
    return <>Вы&nbsp;можете применить скидку еще&nbsp;на&nbsp;{deposit}&nbsp;₽</>
}

function formatReminderUsages(usages: string) {
    return <>Вы&nbsp;можете применить скидку еще&nbsp;{usages}&nbsp;раз</>
}

function formatEndDay(endDay: string) {
    return <>Скидка действует до&nbsp;{endDay}</>
}

function formatPriceLimit(priceLimit: string) {
    return <>Скидка действует на&nbsp;сессии стоимостью до&nbsp;{priceLimit}&nbsp;₽</>
}

function formatDisabledByBalance() {
    return (
        <>
            Скидка неактивна. Обратитесь, пожалуйста, к&nbsp;коллеге, ответственному
            за&nbsp;корпоративные скидки в&nbsp;вашей компании.
        </>
    )
}

interface DiscountDescriptionProps {
    discount: ClientDiscount
}

type DescriptionKeys =
    | "reminder_deposit"
    | "reminder_usages"
    | "end_day"
    | "price_limit"
    | "disabled_by_balance"
type DescriptionFields = {
    [key in DescriptionKeys]: (value: string) => string | ReactNode
}

const DESCRIPTION_FIELDS: DescriptionFields = {
    disabled_by_balance: formatDisabledByBalance,
    reminder_deposit: formatReminderDeposit,
    reminder_usages: formatReminderUsages,
    end_day: formatEndDay,
    price_limit: formatPriceLimit,
}

export const DiscountDescription = memo(
    ({ discount }: DiscountDescriptionProps) => {
        const keys = Object.keys(DESCRIPTION_FIELDS)
        const strings = keys
            .map((key) => {
                const format = DESCRIPTION_FIELDS[key as DescriptionKeys]
                const value = discount[key as DescriptionKeys]
                return value ? format(value.toString()) : null
            })
            .filter(nonNullable)
        return (
            <>
                {strings.map((str, index) => (
                    <Fragment key={index}>
                        {str} {index + 1 !== strings.length && <br />}
                    </Fragment>
                ))}
            </>
        )
    },
    (prev, current) => prev.discount.discount_id === current.discount.discount_id
)

DiscountDescription.displayName = "DiscountDescription"
